import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    useMediaQuery,
} from '@mui/material';
import Paper, { PaperProps } from '@mui/material/Paper';
import React from 'react';
import Draggable from 'react-draggable';
import { CustomButton } from '../../../../../layout/styledcomponents/CustomButton';
import AutoHeightTransition from '../../../../../shared/AutoHeightTransition';
import ReservationJobMenu from './ReservationJobMenu';
import { PricingTemplate } from '../../../../types/contractor';
import { JobItem } from '../../../../../app/Slices/SevenDayApiTypes';
import { JobBookingAvailability } from '../../../Contractors/utils/cutoff.utils';
import ReservationSetMenu from './ReservationSetMenu';
import { SetMenu } from '../../../../types/set-menu';
import { ProviderType } from '../../../../../app/Slices/SevenDayApiTypes';

interface JobMenuModalProps {
    open: boolean;
    onClose: () => void;
    name: string;
    templates: PricingTemplate[];
    onItemsChange?: (items: JobItem[]) => void;
    bookingAvailability: JobBookingAvailability;
    providerType: ProviderType;
    setMenus: SetMenu[];
    numberOfGuests?: number;
}

function PaperComponent(props: PaperProps) {
    const nodeRef = React.useRef<HTMLDivElement>(null);
    return (
        <Draggable
            nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
            handle='#draggable-dialog-title'
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const JobMenuModal: React.FC<JobMenuModalProps> = ({
    open,
    onClose,
    name,
    numberOfGuests,
    templates,
    onItemsChange,
    bookingAvailability,
    providerType,
    setMenus,
}) => {
    const isMobile = useMediaQuery('(max-width: 770px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='md'
            fullWidth
            fullScreen={isMobile}
            PaperComponent={PaperComponent}
            aria-labelledby='draggable-dialog-title'
            PaperProps={{
                sx: {
                    borderRadius: isMobile ? 0 : 2,
                    overflow: 'hidden',
                },
            }}
        >
            <DialogTitle sx={{ cursor: 'move' }}>
                Services
                <IconButton
                    onClick={onClose}
                    size='small'
                    aria-label='close'
                    sx={{ color: 'text.primary', cursor: 'pointer' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Box
                    sx={{
                        width: '100%',
                        height: 'auto',
                    }}
                >
                    <AutoHeightTransition>
                        {providerType === ProviderType.Owner ? (
                            <ReservationSetMenu
                                name={name}
                                setMenus={setMenus}
                                numberOfGuests={numberOfGuests}
                            />
                        ) : (
                            <ReservationJobMenu
                                name={name}
                                templates={templates}
                                onItemsChange={onItemsChange}
                                bookingAvailability={bookingAvailability}
                            />
                        )}
                    </AutoHeightTransition>
                </Box>
            </DialogContent>

            <DialogActions>
                <CustomButton
                    onClick={onClose}
                    variant='contained'
                    color='primary'
                >
                    Ok
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default JobMenuModal;
